import type { Expand } from "../types/Brand"
import { Partial } from "../functions/Partial"

// Get the self type from a module of functions (uses first function's first arg)
type InferSelf<M> = M[keyof M] extends (first: infer T, ...rest: any[]) => any ? T : never

// Takes functions where first arg is `self`, returns bound methods without that arg
type RemoveFirstArg<F> = F extends (first: any, ...rest: infer R) => infer Ret
  ? (...args: R) => Ret
  : never

type BoundMethods<M> = {
  [K in keyof M]: RemoveFirstArg<M[K]>
}

export const EntityFactory = <
  M extends Record<string, (self: any, ...args: any[]) => any>,
  T = InferSelf<M>
>(
  methods: M
): ((props: T) => T & Expand<BoundMethods<M>>) => {
  return (props: T): T & Expand<BoundMethods<M>> => {
    const instance = { ...(props as object) } as unknown as T & Expand<BoundMethods<M>>
    for (const key in methods) {
      ;(instance as any)[key] = Partial(methods[key] as any, instance)
    }
    return instance
  }
}
